import "../style.css";
import Modal from "components/Modal";
import VerifyPhoneCodeForm from "../../Forms/VerifyPhoneCodeForm";
import { useLoggedIn } from "stores/auth/authStore";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";

export const VerifyPhoneCodeModal = () => {
  const { user } = useLoggedIn();
  const close = useModalStore(s => s.close);
  const current = useModalStore(s => s.current);
  const isOpen = current === ModalKey.VerifyPhoneCode;

  return (
    <Modal
      isCloseIcon
      modalIsOpen={isOpen}
      closeModal={close}
      title={"Verification Code"}
      description={`Please enter code sent to ${user?.phone_number}`}
      className="p-10"
    >
      {{
        content: (
          <div>
            <VerifyPhoneCodeForm />
          </div>
        ),
      }}
    </Modal>
  );
};

export default VerifyPhoneCodeModal;
